import { useNavigate } from "react-router-dom";
import { Building2, LayoutGrid } from "lucide-react";
import { AppShell } from "@/components/layout/app-shell";
import { UserMenu } from "@/components/layout/user-menu";
import type { RailNavItem } from "@/components/layout/sidebar-rail";
import { useSuperadminLogout } from "@/hooks/use-auth";

const NAV: RailNavItem[] = [
  { kind: "link", to: "/superadmin", label: "Dashboard", icon: LayoutGrid, end: true },
  { kind: "link", to: "/superadmin/workspaces", label: "Workspaces", icon: Building2 },
];

export default function SuperadminLayout() {
  const logout = useSuperadminLogout();
  const navigate = useNavigate();

  return (
    <AppShell
      brandTo="/superadmin"
      primaryNav={NAV}
      searchPlaceholder="Search workspaces…"
      userMenu={
        <UserMenu
          name="Superadmin"
          roleLabel="Superadmin"
          isLoggingOut={logout.isPending}
          onLogout={() =>
            logout.mutate(undefined, {
              onSuccess: () => navigate("/superadmin/login", { replace: true }),
            })
          }
        />
      }
    />
  );
}
